import { render, staticRenderFns } from "./SensorIcon.vue?vue&type=template&id=56c2f035"
import script from "./SensorIcon.vue?vue&type=script&lang=ts"
export * from "./SensorIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports